import React from 'react';
import BaseDownloadButton from 'src/components/common/BaseDownloadButton';

export interface DownloadReportButtonCommonProps {
    pageUrl: string;
    label?: string;
    params?: Record<string, string | number | undefined>;
    startDate?: Date;
    endDate?: Date;
}

const DownloadReportButtonCommon: React.FC<DownloadReportButtonCommonProps> = ({
    pageUrl,
    label,
    startDate,
    endDate,
    params
}) => {
    return (
        <BaseDownloadButton
            pageUrl={pageUrl}
            label={label}
            params={params}
            dateDefaults={{ startDate, endDate }}
            defaultFileExtension="doc"
        />
    );
};

export default DownloadReportButtonCommon;
